import { render, staticRenderFns } from "./ExpoChapterQuestionEntityDetails.vue?vue&type=template&id=04b46ee4&scoped=true"
import script from "./ExpoChapterQuestionEntityDetails.vue?vue&type=script&lang=js"
export * from "./ExpoChapterQuestionEntityDetails.vue?vue&type=script&lang=js"
import style0 from "./ExpoChapterQuestionEntityDetails.vue?vue&type=style&index=0&id=04b46ee4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b46ee4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04b46ee4')) {
      api.createRecord('04b46ee4', component.options)
    } else {
      api.reload('04b46ee4', component.options)
    }
    module.hot.accept("./ExpoChapterQuestionEntityDetails.vue?vue&type=template&id=04b46ee4&scoped=true", function () {
      api.rerender('04b46ee4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ExpoChapterQuestionEntityDetails.vue"
export default component.exports